module.exports = __webpack_public_path__ + "static/3-bd3fe59a7fd3bc12abfb4e37bdb4af4f.svg";